import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import { employeeLevelsAction, authAction, employeeAction } from '../../../actions/'
import { authSelector, employeeLevelsSelector, employeeSelector } from '../../../selectors'
import CustomTable from '../../../components/table'

const header = ['Start Date', 'Pay Grade ID', 'Pay Grade Name', 'Modified By']

class ListEmployeeLevels extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      employeeLevels: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getEmployeeList(access_token)
    this.props.listEmployeeLevels(access_token)
  }

  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'listEmployeeLevelsData')) {
      this.setState({ employeeLevels: get(nextProps, 'listEmployeeLevelsData') })
    }
  }
  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }
  render() {
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')

    if (IsSystemUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      !(IsSystemUser || IsHRConfidentialUser)) window.location = '/home'

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTable
        header={ header }
        data={ this.props.levels }
        handleClickEdit={ this.handleClickEdit }
        span={ get(this.props, 'span') }
        table={ this.props.table }
        employeeList={ this.props.employeeList }
      />
    )
  }
}

ListEmployeeLevels.propTypes = {
  listEmployeeLevels: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.array.isRequired,
  handleSpan: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  listEmployeeLevelsData: employeeLevelsSelector.getListEmployeeLevels,
  employeeLevelsDeactivate: employeeLevelsSelector.getDeactivateEmployeeLevelsData,
  redirectEmployeeLevels: employeeLevelsSelector.redirectEmployeeLevels,
  authData: authSelector.getAuth,
  employeeList: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listEmployeeLevels: employeeLevelsAction.getEmployeeLevels,
  deactivateEmployeeLevels: employeeLevelsAction.deactivateEmployeeLevels,
  resetDeactivateEmployeeLevels: employeeLevelsAction.resetDeactivateEmployeeLevels,
  resetListEmployeeLevels: employeeLevelsAction.resetListEmployeeLevels,
  getAuth: authAction.auth,
  getEmployeeList: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListEmployeeLevels)



// WEBPACK FOOTER //
// ./src/pages/employee-levels/list/index.js